import useCountriesStore from '~/stores/useCountriesStore'

/**
 * Проверяет, является ли url доверенным для редиректа
 * */
export const isTrustedUrl = async (url: string) => {
  if (url.startsWith('/')) {
    return true
  }

  try {
    const urlObj = new URL(url)

    if (urlObj.origin === location.origin) {
      return true
    }

    if (process.env.pdSmokeUrl && (new URL(process.env.pdSmokeUrl).origin === urlObj.origin)) {
      return true
    }

    const countriesStore = useCountriesStore()

    if (!countriesStore.countriesItems.length) {
      await countriesStore.fetchCountries()
    }

    return countriesStore.countriesItems.some(({ pdDomain }) => urlObj.hostname === pdDomain)
  } catch {
    return false
  }
}
